import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAppSelector as useSelector } from "../hooks/redux";

const PrivateRoute = ({
  children,
  path,
  ...rest
}: RouteProps): React.ReactElement => {
  const state = useSelector((s) => s.admin);

  if (!state.email) {
    //return <Redirect to={`login/${hash}`} />;
    return <Redirect to={`/`} />;
  }
  return (
    <Route path={path} {...rest}>
      {children}
    </Route>
  );
};

export default PrivateRoute;
